import * as yup from 'yup'

const confluenceAuthFormValidationSchema = yup
  .object()
  .shape({
    accountUrl: yup.string().trim().required('Account URL is required').url('Please enter a valid url'),
    installCode: yup.string().trim().required('Installation code is required')
  })
  .required()

export default confluenceAuthFormValidationSchema
